import clsx from 'clsx'
import { usePathname } from 'next/navigation'
import React, { Fragment, useMemo } from 'react'

import BookingSection, { BookingSectionProps } from 'lib/components/BookingSection/BookingSection'
import Stepper from 'lib/components/Stepper/Stepper'

import { BookingFlowProps, BookingFlowStep } from '@/types/bookingFlow'

export interface ExtendedBookingFlowStep extends BookingFlowStep {
  title: string
  path: string
}

const BookingFlow: React.FC<BookingFlowProps> = ({
  steps = [],
  hideCurrentStep = false,
  hideSteps = false,
  currentStep = 0,
  topContents,
  bottomContents,
  children,
  sidebar,
}) => {
  const pathname = usePathname()

  const completedSteps = steps
    .map(({ number, completed }) => (completed ? number : null))
    .filter(Boolean) as number[]

  const extendedSteps: ExtendedBookingFlowStep[] = steps as ExtendedBookingFlowStep[]
  const isLoginPage = useMemo(() => pathname === '/book/login', [pathname])

  return (
    <>
      {/* Layout for Desktop view */}
      <div className="bg-neutral-200 lg:hidden">
        <Stepper steps={steps.length} current={currentStep} completed={completedSteps} />
      </div>

      <div className="container pb-[104px] pt-6 lg:py-10">
        <div className="col-span-full lg:col-span-7">
          {topContents}
          {steps?.length && !hideSteps ? (
            <div className={clsx('flex flex-col gap-6', topContents && 'mt-6 md:mt-8')}>
              {extendedSteps.map(({ number, title, completed = false, path }) => (
                <Fragment key={path}>
                  {(!hideCurrentStep || (hideCurrentStep && currentStep !== number)) &&
                  !(isLoginPage && number === 2) ? (
                    <BookingSection
                      key={number}
                      step={number as BookingSectionProps['step']}
                      title={title}
                      isExpanded={currentStep !== number}
                      completed={currentStep !== number && completed}
                      edit={completed && currentStep !== number && path ? path : false}
                    >
                      {currentStep === number && children}
                    </BookingSection>
                  ) : (
                    children
                  )}
                </Fragment>
              ))}
            </div>
          ) : (
            <div className={clsx('flex flex-col gap-6', topContents && 'mt-6 md:mt-8')}>
              {children}
            </div>
          )}
          {bottomContents}
        </div>
        <div className="col-span-full lg:col-span-5">{sidebar}</div>
      </div>
    </>
  )
}

export default BookingFlow
